/* Generated by TinySVG. Do not edit directly. */
import type { TinyIconProps } from '../types.ts'

export function RocketIcon({
  size = 24,
  color = 'currentColor',
  strokeWidth,
  title,
  ...svgProps
}: TinyIconProps) {
  const resolvedStrokeWidth = strokeWidth ?? 1.75
  const scaledStrokeWidth = (percent: number) => {
    const numericStrokeWidth = typeof resolvedStrokeWidth === 'number' ? resolvedStrokeWidth : Number(resolvedStrokeWidth)
    return Number.isFinite(numericStrokeWidth) ? numericStrokeWidth * percent / 100 : resolvedStrokeWidth
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      strokeWidth={resolvedStrokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      data-icon="rocket"
      data-variant="outline"
      role={title ? 'img' : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
          <path d="M3.562 13.65A5.34 5.34 45 0 1 10.35 20.438" data-tinysvg-shape="arc" data-tinysvg-arc="5.302 18.698 5.34 5.34 205.989 334.011 45 three-point" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M15.442 15.347A3.9 3.9 45 0 1 10.35 20.438" data-tinysvg-shape="arc" data-tinysvg-arc="11.835 16.832 3.9 3.9 292.62 427.38 45 three-point" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M20.109 3.891A11.825 11.825 45 0 1 15.442 15.347" data-tinysvg-shape="arc" data-tinysvg-arc="8.441 5.816 11.825 11.825 305.632 368.701 45 three-point" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M8.653 8.558A11.825 11.825 45 0 1 20.109 3.891" data-tinysvg-shape="arc" data-tinysvg-arc="18.184 15.559 11.825 11.825 171.299 234.368 45 three-point" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M3.562 13.65A3.9 3.9 45 0 1 8.653 8.558" data-tinysvg-shape="arc" data-tinysvg-arc="7.168 12.165 3.9 3.9 112.62 247.38 45 three-point" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M15.442 8.558L15.442 8.558" data-tinysvg-shape="line" stroke={color} fill="none" data-stroke-tone="primary" strokeWidth={scaledStrokeWidth(166.667)} data-tinysvg-stroke-width="166.667" />
          <path d="M3.5 20.5A9.329 9.329 0 0 1 4.835 16.619" data-tinysvg-shape="arc" data-tinysvg-arc="12.774 21.52 9.329 9.329 186.278 211.689 0 three-point" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M4.835 16.619A1.966 1.966 0 0 1 7.381 19.165" data-tinysvg-shape="arc" data-tinysvg-arc="5.549 18.451 1.966 1.966 248.697 381.3 0 three-point" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M7.381 19.165A9.331 9.331 0 0 1 3.5 20.5" data-tinysvg-shape="arc" data-tinysvg-arc="2.479 11.225 9.331 9.331 58.311 83.719 0 three-point" stroke={color} fill="none" data-stroke-tone="primary" />
    </svg>
  )
}
